<template>
  <div class="cov-vue-date">
    <div class="datepickbox">
      <template v-if="disabled">
        <div class="fa fa-clock-o icon-search cov-datepicker" :style="option.inputStyle ? option.inputStyle : {}"></div>
      </template>
      <template v-else>
        <div class="fa fa-clock-o icon-search cov-datepicker" @click="checkDay" :style="option.inputStyle ? option.inputStyle : {}"></div>
      </template>
      <input type="hidden" readonly="readonly" :placeholder="option.placeholder" v-model="date.time" :required="required">
    </div>

    <div class="datepicker-overlay" v-if="showInfo.check" @click="dismiss($event)" v-bind:style="{'background' : option.overlayOpacity? 'rgba(0,0,0,'+option.overlayOpacity+')' : 'rgba(0,0,0,0.5)'}">
      <div class="cov-date-body" :style="{'background-color': option.color ? option.color.header : '#3f51b5'}">
        <div class="cov-date-box list-box">
          <div class="cov-picker-box date-list">
            <div class="watch-box">  
              <div class="hour-box">
                <div class="head-hour bg-color-skin-dark-20 border-color-skin-dark-10">Hour</div>
                <div class="mui-pciker-rule mui-pciker-rule-ft"></div>
                <ul>
                  <li class="hour-item" v-for="hitem in hours" @click="setTime('hour', hitem, hours)" :class="{'active':hitem.value == checked.hour}">{{hitem.value}}</li>
                </ul>
              </div>
              <div class="min-box">
                <div class="head-min bg-color-skin-dark-20">Minute</div>
                <div class="mui-pciker-rule mui-pciker-rule-ft"></div>
                <ul>
                  <li class="min-item" v-for="mitem in mins" @click="setTime('min',mitem, mins)" :class="{'active':mitem.value == checked.min}">{{mitem.value}}</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div class="button-box">
          <span @click="showInfo.check=false">{{option.buttons? option.buttons.cancel : 'Cancel' }}</span>
          <span @click="picked">{{option.buttons? option.buttons.ok : 'Ok'}}</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
'use strict'

Object.defineProperty(exports, '__esModule', {
  value: true
})

var _moment = require('moment')

var _moment2 = _interopRequireDefault(_moment)

function _interopRequireDefault (obj) { return obj && obj.__esModule ? obj : { default: obj } }

exports.default = {
  props: {
    required: false,
    date: {
      type: Object,
      required: true
    },
    option: {
      type: Object,
      default: function _default () {
        return {
          format: 'HH:mm',
          color: {
            checked: '#F50057',
            header: '#3f51b5',
            headerText: '#fff'
          },
          inputStyle: {
            'display': 'inline-block',
            'padding': '6px',
            'line-height': '22px',
            'font-size': '16px',
            'border': '2px solid #fff',
            'box-shadow': '0 1px 3px 0 rgba(0, 0, 0, 0.2)',
            'border-radius': '2px',
            'color': '#5F5F5F'
          },
          buttons: {
            ok: 'OK',
            cancel: 'Cancel'
          },
          overlayOpacity: 0.5,
          dismissible: true
        }
      }
    },
    limit: {
      type: Array,
      default: function _default () {
        return []
      }
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data: function data () {
    function hours () {
      var list = []
      var hour = 24
      while (hour > 0) {
        hour--
        list.push({
          checked: false,
          value: hour < 10 ? '0' + hour : hour
        })
      }
      return list
    }
    function mins () {
      var list = []
      var min = 60
      while (min > 0) {
        min--
        list.push({
          checked: false,
          value: min < 10 ? '0' + min : min
        })
      }
      return list
    }
    return {
      hours: hours(),
      mins: mins(),
      showInfo: {
        hour: false,
        check: false
      },
      checked: {
        oldtime: '',
        currentMoment: null,
        hour: '00',
        min: '00'
      }
    }
  },
  watch: {
    checked (newVal) {
      this.checked = newVal
    }
  },
  methods: {
    pad: function pad (n) {
      n = Math.floor(n)
      return n < 10 ? '0' + n : n
    },
    checkDay: function checkDay (obj) {
      if (obj.unavailable || obj.value === '') {
        return false
      }
      if (this.date.time !== '') {
        this.checked['hour'] = this.date.time.substr(0, 2)
        this.checked['min'] = this.date.time.substr(3, 2)
      }
      this.showInfo.hour = true
      // shift activated time items to visible position.
      this.shiftActTime()
      this.showInfo.check = true
    },
    setTime: function setTime (type, obj, list) {
      var _iteratorNormalCompletion2 = true
      var _didIteratorError2 = false
      // var _iteratorError2

      try {
        for (var _iterator2 = list[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var item = _step2.value

          item.checked = false
          if (item.value === obj.value) {
            item.checked = true
            this.checked[type] = item.value
          }
        }
      } catch (err) {
        _didIteratorError2 = true
        // _iteratorError2 = err
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return()
          }
        } finally {
          if (_didIteratorError2) {
            // throw _iteratorError2
          }
        }
      }
    },
    picked: function picked () {
      var ctime = this.checked.hour + ':' + this.checked.min
      this.checked.currentMoment = (0, _moment2.default)(ctime, 'HH:mm')
      this.date.time = (0, _moment2.default)(this.checked.currentMoment).format(this.option.format)
      this.showInfo.check = false
      this.$emit('change', this.date.time)
    },
    dismiss: function dismiss (evt) {
      if (evt.target.className === 'datepicker-overlay') {
        if (this.option.dismissible === undefined || this.option.dismissible) {
          this.showInfo.check = false
          this.$emit('cancel')
        }
      }
    },
    shiftActTime: function shiftActTime () {
      // shift activated time items to visible position.
      this.$nextTick(function () {
        if (!document.querySelector('.hour-item.active')) {
          return false
        }
        document.querySelector('.hour-box').scrollTop = (document.querySelector('.hour-item.active').offsetTop || 0) - 250
        document.querySelector('.min-box').scrollTop = (document.querySelector('.min-item.active').offsetTop || 0) - 250
      })
    }
  }
}
</script>

<style scoped>
.datepicker-overlay {
  position: fixed;
  width: 100%;
  height: 100%;
  z-index: 998;
  top: 0;
  left: 0;
  overflow: hidden;
  -webkit-animation: fadein 0.5s;
  /* Safari, Chrome and Opera > 12.1 */
  -moz-animation: fadein 0.5s;
  /* Firefox < 16 */
  -ms-animation: fadein 0.5s;
  /* Internet Explorer */
  -o-animation: fadein 0.5s;
  /* Opera < 12.1 */
  animation: fadein 0.5s;
}
@keyframes fadein {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
/* Firefox < 16 */
@-moz-keyframes fadein {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
/* Safari, Chrome and Opera > 12.1 */
@-webkit-keyframes fadein {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
/* Internet Explorer */
@-ms-keyframes fadein {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
/* Opera < 12.1 */
@-o-keyframes fadein {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
.cov-date-body {
  display: inline-block;
  background: #3F51B5;
  overflow: hidden;
  position: relative;
  font-size: 16px;
  font-family: 'cloud_lightlight';
  font-weight: 400;
  position: fixed;
  display: block;
  width: 400px;
  max-width: 100%;
  z-index: 999;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  box-shadow: 0 1px 3px 3px rgba(0, 0, 0, 0.2);
}
.cov-picker-box {
  background: #fff;
  width: 100%;
  display: inline-block;
  padding: 25px;
  box-sizing: border-box !important;
  -moz-box-sizing: border-box !important;
  -webkit-box-sizing: border-box !important;
  -ms-box-sizing: border-box !important;
  width: 400px;
  max-width: 100%;
  height: 280px;
  text-align: start!important;
}
.cov-picker-box td {
  height: 34px;
  width: 34px;
  padding: 0;
  line-height: 34px;
  color: #000;
  background: #fff;
  text-align: center;
  cursor: pointer;
}
.cov-picker-box td:hover {
  background: #E6E6E6;
}
table {
  border-collapse: collapse;
  border-spacing: 0;
  width: 100%;
}
.checked {
  background: #F50057;
  color: #FFF !important;
  border-radius: 3px;
}
.unavailable {
  color: #ccc;
  cursor: not-allowed;
}
.unavailable:hover {
  background: none;
}
.checked:hover {
  background: #FF4F8E;
}
.date-list {
  overflow: auto;
  vertical-align: top;
  padding: 0;
}
.button-box {
  background: #fff;
  vertical-align: top;
  height: 50px;
  line-height: 50px;
  text-align: right;
  padding-right: 20px;
}
.button-box span {
  cursor: pointer;
  padding: 10px 20px;
}
.watch-box {
  height: 100%;
  overflow: hidden;
}
.head-hour{
  width:50%;
  text-align:center;
  color:#FFF;
  font-size:32px;
  padding:15px 0;
  position:absolute;
  top:0;
  border-right:1px solid #424242;
}
.head-min{
  width:50%;
  text-align:center;
  color:#FFF;
  font-size:32px;
  padding:15px 0;
  position:absolute;
  top:0;
}
.hour-box,
.min-box {
  display: inline-block;
  width: 50%;
  text-align: center;
  height: 100%;
  overflow: auto;
  float: left;
}
.hour-box ul,
.min-box ul {
  list-style: none;
  margin: 75px 0 0 0;
  padding: 0;
}
.hour-item,
.min-item {
  padding: 10px;
  font-size: 36px;
  cursor: pointer;
}
.hour-item:hover,
.min-item:hover {
  background: #E3E3E3;
}
.hour-box .active,
.min-box .active {
  background: #757575;
  color: #FFF !important;
}
::-webkit-scrollbar {
  width: 2px;
}
::-webkit-scrollbar-track {
  background: #E3E3E3;
}
::-webkit-scrollbar-thumb {
  background: #C1C1C1;
  border-radius: 2px;
}
</style>


// WEBPACK FOOTER //
// component.vue?e870e36c